import { render } from "./LogoApp.vue?vue&type=template&id=3fb5350a"
import script from "./LogoApp.vue?vue&type=script&lang=js"
export * from "./LogoApp.vue?vue&type=script&lang=js"

import "./LogoApp.vue?vue&type=style&index=0&id=3fb5350a&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__